type CmsAttribute = {
    'data-mdlfy-cms'?: string
}

/**
 * Marks an element as holding exactly one database text value, so it can be edited in place
 * in the preview. Always pass the real table name, the row's surrogate id and the real column name.
 */
export const cms = (table: string, id: string | null | undefined, column: string): CmsAttribute => {
    if (!id) return {}

    return { 'data-mdlfy-cms': `${table}:${id}:${column}` }
}
